export default __webpack_public_path__ + "static/media/mapPreferenceIcon.7a00b190.svg";